/*******************************************************
 * LEAFLET SERVICE
 *
 * En charge
 * - d'afficher une carte leaflet
 * - gérer affichage de markers
 *******************************************************/


angular.module("services").factory("OkinaLeafletService", [
	"ENV", "MapUtils", "Utils", "FitiSubscriptionService", "leafletData", "$compile", "$timeout", "leafletMarkersHelpers", "SecurityService",
	function (ENV, MapUtils, Utils, FitiSubscriptionService, leafletData, $compile, $timeout, leafletMarkersHelpers, SecurityService) {

        "use strict";

        let scaleControl;
        let mapId;
        let drawControl;
        let editionManager = {
            currentMode: "",
            selectedShape: null
        };
        let timeout;
        let defaultOptionsMarkerClusterGroup = {
            chunkedLoading: true,
            maxClusterRadius: function (zoom) {
                return (zoom < 18) ? 80 : 10;
            },
            disableClusteringAtZoom: 16
        };
        const RULE_POLYLINE = "RULE_POLYLINE";
        let api = {

            // Variables
            // data storage. Can be accessed accross angular objects
            markers: [],
            containerFeatureGroup: new L.featureGroup(),
            geojsonFeatureGroup: new L.featureGroup(),
            markersFeatureGroup: new L.featureGroup(),
            legend: null,
            directiveProperties: { // Utilisé par la directive OkinaMap
                overlays: {},
                markers: [],
                overlayLoadedCallback: null
            },
            widgets: [],
            editionManager: editionManager,
            zoomOffset: null,

            // API Functions / variables
            RULE_POLYLINE: "RULE_POLYLINE",
            init: init,
            reset: reset,
            getMapId: getMapId,
            getMap: getMap,
            invalidateSize: invalidateSize,

            // Overlays Controller Methods
            hideOverlay: hideOverlay,
            showOverlay: showOverlay,
            createMarkerOnLayer: createMarkerOnLayer,
            deleteLayersOnLayer: deleteLayersOnLayer,

            createMarker: createMarker,
            createMarkerWithName: createMarkerWithName,
            bulkAddMarkerWithName: bulkAddMarkerWithName,
            getMarkerWithName: getMarkerWithName,
            markerFaCustomization: markerFaCustomization,
            deleteAllMarkers: deleteAllMarkers,
            deleteMarkerWithName: deleteMarkerWithName,
            deleteMarkerWithNameStartingBy: deleteMarkerWithNameStartingBy,
            deleteMarker: deleteMarker,
            getMarkers: function () {
                return api.markers;
            },
            getIcon: getIcon,
            unselectAllMarkers: unselectAllMarkers,
            unselectAllMarkersWithType: unselectAllMarkersWithType,

            setCenter: setCenter,
            setMapLegend: setMapLegend,
            getMapLegend: getMapLegend,
            setZoom: setZoom,
            zoomOnLayer: zoomOnLayer,
            zoomOnBounds: zoomOnBounds,
            zoomToVisibleElements: zoomToVisibleElements,
            bringContainerLayerToFront: bringContainerLayerToFront,

            setOverlayLoadedCallback: setOverlayLoadedCallback,
            addEventOnMap: addEventOnMap,
            closeLastPopup: closeLastPopup,

            addShapeGeoJson: addShapeGeoJson,
            addShapeGeoJsonToLayer: addShapeGeoJsonToLayer,
            addPolyline: addPolyline,
            removeShapeGeoJson: removeShapeGeoJson,
            getGeoJSONShapeList: getGeoJSONShapeList,
            deleteGeoJsonLayers: deleteGeoJsonLayers,
            deleteGeoJsonLayer: deleteGeoJsonLayer,
            deleteAllLayersToLayer: deleteAllLayersToLayer,
            selectShape: selectShape,

            // Méthode pour le tracé
            addDrawControls: addDrawControls,
            setDrawControlsVisibility: setDrawControlsVisibility,
            calculateRoutePolyline: calculateRoutePolyline,
            getAsCrowsFliesDistanceFromRule: getAsCrowsFliesDistanceFromRule,
            addScaleControl: addScaleControl,

            toggleMarker: toggleMarker,

            addWidget: addWidget,
            hideWidget: hideWidget,
            showWidget: showWidget,
        };

        /** PRIVATE FUNCTIONS **/

        function getMap() {
            return leafletData.getMap(mapId);
        }

        function invalidateSize() {
            getMap().then(map => map.invalidateSize());
        }

        /**
         * Ajoute un marker
         * @param marker
         * @returns {*}
         */
        function addMarker(marker) {
            let leafletMarker = createLeafletMarker(marker);

            getMap().then(() => {
                api.markersFeatureGroup.addLayer(leafletMarker);
            });

            return leafletMarker;
        }

        /**
         * Créé un marker leaflet
         * @param marker
         * @returns {*|L.marker}
         */
        function createLeafletMarker(marker) {
            let leafletMarker = leafletMarkersHelpers.createMarker(marker);

            if (marker.message != null) {
                leafletMarker.bindPopup(function (layer) {
                    if (layer.options.getMessageScope != null && angular.isFunction(layer.options.getMessageScope)) {
                        // Gestion manuelle du contexte du message pour gérer Angular
                        let linkFn = $compile(layer.options.message);
                        let content = linkFn(layer.options.getMessageScope());
                        return content[0];
                    } else {
                        return layer.options.message;
                    }
                });

                if (marker.popupMaxHeight) {
                    leafletMarker._popup.options.maxHeight = marker.popupMaxHeight;
                }

                if (marker.popupMaxWidth) {
                    leafletMarker._popup.options.maxWidth = marker.popupMaxWidth;
                }
            } else {
                leafletMarker.unbindPopup();
            }

            if (marker.onClick != null) {
                leafletMarker.on("click", function (event) {
                    event.target.options.onClick(event);
                });
            }

            if (marker.onPopupOpen != null) {
                leafletMarker.on("popupopen", function (event) {
                    event.target.options.onPopupOpen(event);
                });
            }

            return leafletMarker;
        }

        /**
         * Retourne un object LeafLet.AwesomeMarkers.icon
         * dans son état selected ou non
         *
         * @param selected
         * @param icon > potential font-awesome icon
         * @returns {L.AwesomeMarkers.Icon}
         */
        function getIcon(selected, icon) {
            return L.AwesomeMarkers.icon({
                type: "awesomeMarker",
                icon: angular.isDefined(icon) ? icon : "circle",
                prefix: "fa",
                markerColor: selected ? "red" : "blue",
            });
        }

        /**
         * Met l'icone déselectionné à tous les markers de la map
         * @param icon > potential font-awesome icon
         */
        function unselectAllMarkers(icon) {
            api.markers.forEach(function (marker) {
                marker.setIcon(getIcon(false, icon));
            });
        }

        /**
         * Met l'icone déselectionné à tous les markers de la map
         * @param type > le marker.type à unselect
         * @param icon > potential font-awesome icon
         */
        function unselectAllMarkersWithType(type, icon) {
            api.markers.forEach(function (marker) {
                if (marker.options != null && marker.options.type === type) {
                    marker.setIcon(getIcon(false, icon));
                }
            });
        }

        /**
         * Méthode ramenant le layer contenant tous les éléments tracés au devant des overlays
         * Hack : Suppression du layer et rajout du layer
         */
        function bringContainerLayerToFront() {
            getMap().then((map) => {
                map.removeLayer(api.containerFeatureGroup);
                map.addLayer(api.containerFeatureGroup);
            });
        }

        /**
         * Simule l'envoi d'un event interne de la map leaflet
         * @param eventName
         * @param target
         */
        function fireMapEvent(eventName, target) {
            getMap().then((map) => {
                // Lance l'event overlayadd
                let eventHandlers = map._events[eventName];
                if (eventHandlers != null) {
                    for (let handler in eventHandlers) {
                        eventHandlers[handler].fn(target);
                    }
                } else {
                    console.error("Event : " + eventName + " unknown.");
                }
            });
        }

        /**
         * Traduis les locales pour les éléments de polylines et de polygones
         */
        function translateDrawControlsInFrench() {
            // Polygon
            L.drawLocal.draw.handlers.polygon.tooltip.cont = "Cliquer pour continuer à dessiner la forme.";
            L.drawLocal.draw.handlers.polygon.tooltip.end = "Cliquer sur le premier point pour finir cette forme.";
            L.drawLocal.draw.handlers.polygon.tooltip.start = "Cliquer pour commencer à dessiner la forme.";

            // Polyline
            L.drawLocal.draw.handlers.polyline.tooltip.cont = "Cliquer pour continuer à dessiner la ligne.";
            L.drawLocal.draw.handlers.polyline.tooltip.end = "Cliquer sur le dernier point pour finir cette ligne.";
            L.drawLocal.draw.handlers.polyline.tooltip.start = "Cliquer pour commencer à dessiner la ligne.";

            // Global
            L.drawLocal.draw.toolbar.actions.text = "Annuler";
            L.drawLocal.draw.toolbar.actions.title = "Annuler le tracé";
            L.drawLocal.draw.toolbar.buttons.polygon = "Tracer un polygone.";
            L.drawLocal.draw.toolbar.buttons.polyline = "Tracer une ligne.";
            L.drawLocal.draw.toolbar.finish.text = "Finir";
            L.drawLocal.draw.toolbar.finish.title = "Finir le tracé";
            L.drawLocal.draw.toolbar.undo.text = "Supprimer le dernier point";
            L.drawLocal.draw.toolbar.undo.title = "Supprimer le dernier point tracé";
        }

        /** PUBLIC FUNCTIONS **/

        /**
         * Initialise la map
         * @param newMapId
		 * @param options
         */
        function init(newMapId, options) {

            if (mapId !== undefined && newMapId != mapId) {
                defaultOptionsMarkerClusterGroup.isCluster = null;
            }

            mapId = newMapId;

            // Reset la carte pour éviter les reliquats sur d'autres écrans
            api.widgets = [];
            reset();

            // Initialise la callback par défaut
            setOverlayLoadedCallback(null);

            // On réinitialise l'offset
            api.zoomOffset = null;

            if (options) {
                if (options.zoomOffset) {
                    api.zoomOffset = options.zoomOffset;
                }
            }

            getMap().then((map) => {
                if (api.directiveProperties.overlays.length != 0) {
                    for (const overlayKey in api.directiveProperties.overlays) {
                        const overlay = api.directiveProperties.overlays[overlayKey].layer;
                        // Permet de forcer l'affichage du container des points et shapes au dessus
                        // de l'overlay pour le cas d'un markercluster qui lance l'évennement animationend
                        // lorsqu'il a fini de tracer les points avec un unspiderfied
                        if (overlay) {
                            overlay.on("animationend", function (e) {
                                if (api.directiveProperties.overlays[overlayKey].display) {
                                    bringContainerLayerToFront();
                                }
                            });
                            map.addLayer(overlay);
                        }
                    }
                }

                if (options && options.markerLayerCluster) {
                    api.markersFeatureGroup = new L.markerClusterGroup(defaultOptionsMarkerClusterGroup);
                    if (angular.isFunction(options.cbClusterClick)) {
                        defaultOptionsMarkerClusterGroup.cbClusterClick = options.cbClusterClick;
                        api.markersFeatureGroup.on("clusterclick", (e) => options.cbClusterClick(e));
                    }
                    api.markersFeatureGroup.isCluster = true;
                }

                defaultOptionsMarkerClusterGroup.isCluster = api.markersFeatureGroup.isCluster;
                api.containerFeatureGroup.addLayer(api.geojsonFeatureGroup);
                api.containerFeatureGroup.addLayer(api.markersFeatureGroup);
                map.addLayer(api.containerFeatureGroup);
                // Force le container principal a être au dessus des overlays
                map.on("overlayadd", function () {
                    bringContainerLayerToFront();
                });

                addControlPlaceholders(map);
                addScaleControl(map, {
                    "position": "bottomright",
                    "imperial": false
                });
            });
        }

        /**
         * Réinitialiser
         * doClearMarkersOnReset Détermine si les marqueurs doivent également être supprimés de la carte
         */
        function reset() {
            deleteGeoJsonLayers();
            deleteAllMarkers();
        }

        /**
         * retourne la legend de la map
         * @returns {null}
         */
        function getMapLegend() {
            return api.legend;
        }

        /**
         * Modification de la légende directement par la librairie Leaflet et non la directive.
         * @param legend
         */
        function setMapLegend(legend) {
            getMap().then((map) => {
                if (api.legend != null) {
                    map.removeControl(api.legend);
                }
                if (legend != null) {
                    let legendControl = L.control({position: legend.position});

                    legendControl.onAdd = function () {

                        let div = L.DomUtil.create("div", "info legend");

                        // loop through our density intervals and generate a label with a colored square for each interval
                        for (let i = 0; i < legend.labels.length; i++) {
                            let label = legend.labels[i];
                            div.innerHTML +=
                                "<i style=\"background:" + label.color + "\"></i> " + label.name + "<br/>";
                        }

                        return div;
                    };

                    legendControl.addTo(map);

                    api.legend = legendControl;
                }
            });
        }

        /**
         * Définir le centre de la carte
         */
        function setCenter(newCenter, animate) {
            getMap().then((map) => {
				let zoom = newCenter.zoom;
				if (!zoom) {
					zoom = map.getZoom();
				}
				// Fix for cluster when zooming on spideryfied marker
				// Si bug sur double zoom sur une carto cluster voir le code ci-dessous
				// if (api.markersFeatureGroup.isCluster) {
				// 	api.markersFeatureGroup.once("animationend", () => {
				// 		map.setView(newCenter, zoom);
				// 	});
				// }

				if (animate) {
					map.flyTo([newCenter.lat, newCenter.lng], zoom);
				} else {
					map.setView(newCenter, zoom);
				}
            });
        }

        /**
         * Change le niveau de zoom sans changer le center
         * @param zoom
         */
        function setZoom(zoom) {
            getMap().then((map) => {
                map.setZoom(zoom);
            });
        }

        /**
         * Zoom sur un layer en particulier
         * @param layer
         * @return boolean si le zoom a pu etre fait ou non
         */
        function zoomOnLayer(layer) {
            return zoomOnBounds(layer.getBounds());
        }

        /**
         * Zoom sur des bounds précise
         * @param bounds
         * @returns {boolean}
         */
        function zoomOnBounds(bounds) {
            if (bounds == null || bounds._northEast === undefined) {
                return false;
            } else {
                getMap().then((map) => {
                    map.fitBounds(bounds.pad(0.2), api.zoomOffset);
                });
                return true;
            }
        }

        /**
         * Récupérer l'id de la map
         */
        function getMapId() {
            return mapId;
        }

        /**
         * Supprimer tous les markers
         */
        function deleteAllMarkers() {
            return new Promise((resolve) => {
                api.markers = [];

                getMap().then(function () {
                    api.containerFeatureGroup.removeLayer(api.markersFeatureGroup);
                    api.markersFeatureGroup = api.markersFeatureGroup.isCluster ? new L.markerClusterGroup(defaultOptionsMarkerClusterGroup) : new L.featureGroup();
                    api.containerFeatureGroup.addLayer(api.markersFeatureGroup);
                    if (angular.isFunction(defaultOptionsMarkerClusterGroup.cbClusterClick)) {
                        api.markersFeatureGroup.on("clusterclick", (e) => defaultOptionsMarkerClusterGroup.cbClusterClick(e));
                    }
                    api.markersFeatureGroup.isCluster = defaultOptionsMarkerClusterGroup.isCluster;
                    resolve();
                });
            });
        }

        function deleteLayersOnLayer(overlay) {
            getMap().then(function () {
                overlay.eachLayer(function (layer) {
                    overlay.removeLayer(layer);
                });
            });
        }

        /**
         * Ajoute une marker sur un overlay donné
         * @param marker
         * @param overlay
         * @returns {*|L.marker}
         */
        function createMarkerOnLayer(marker, overlay) {
            let leafletMarker = createLeafletMarker(marker);

            getMap().then(() => {
                leafletMarker.addTo(overlay);
            });

            return leafletMarker;
        }

        /**
         * Ajouter un marker
         * @param marker
         */
        function createMarker(marker) {
            api.markers.push(addMarker(marker));
        }

        /**
         * Ajouter un marker possédant un nom
         * @param name, marker
         */
        function createMarkerWithName(name, marker) {
            api.markers[name] = addMarker(marker);
        }

        /**
         * Ajoute un lot de marker sur le layer principal des markers
         *
         * La liste fournie doit être au format : [{name: "MarkerName", marker: {markerDefinition}]
         * @param list
         * @param finishedCallback
         */
        function bulkAddMarkerWithName(list, finishedCallback) {
            api.containerFeatureGroup.removeLayer(api.markersFeatureGroup);

            // On ajoute la callback une fois l'ajout fini
            api.markersFeatureGroup
                .options
                .chunkProgress = (processed, total, elapsed) => {
                if (processed === total && finishedCallback) {
                    // Affichage terminé on callback et on ajoute le layer
                    finishedCallback();
                    api.markersFeatureGroup.options.chunkProgress = null;
                }
            };

            // Les markers doivent être ajoutés au layer sans que celui-ci ne soit présent sur la carto
            list.forEach(({name, marker}) => {
                const leafletMarker = createLeafletMarker(marker);

                api.markers[name] = leafletMarker;
                api.markersFeatureGroup.addLayer(leafletMarker);
            });

            api.containerFeatureGroup.addLayer(api.markersFeatureGroup);
        }

        /**
         * Returns a marker
         * @param name
         * @returns {*}
         */
        function getMarkerWithName(name) {
            return api.markers[name];
        }

        /**
         * Supprime tous les markers commençant par une certaine chaine de caractère
         * Permet de classer et de gérer les markers par thématique
         * @param prefix
         */
        function deleteMarkerWithNameStartingBy(prefix) {
            for (let key in api.markers) {
                if (key.startsWith(prefix)) {
                    deleteMarkerWithName(key);
                }
            }
        }

        /**
         * Delete an existing marker on the leaflet and on the array api.markers
         * @param name
         */
        function deleteMarkerWithName(name) {
			let marker = api.markers[name];
			if ( marker == null || marker === 'undefined'){
				return;
			}
            api.markersFeatureGroup.removeLayer(api.markers[name]);
            // On supprime le marker de la map api.markers
            for (let key in api.markers) {
                if (key == name) { // attention laisser en == car la key est en string et le name en integer
                    delete api.markers[key];
                    return;
                }
            }
        }

        /**
         * Supprime le marker passé en paramètre
         * @param marker
         */
        function deleteMarker(marker) {
            api.markersFeatureGroup.removeLayer(marker);
            // On supprime le marker de la map api.markers
            api.markers = api.markers.filter(m => {
                let options = m.options;
                let optionsMarker = marker.options;

                return options == null
                    || optionsMarker == null
                    || options.id !== optionsMarker.id;
            });
        }

        /**
         * Personnaliser un marker
         * icon : 'flag', 'university'
         * color : 'white', 'blue', 'green'
         * @param marker
         * @param icon
         * @param color
         * @returns {*}
         */
        function markerFaCustomization(marker, icon, color) {
            marker.icon = {
                type: "awesomeMarker",
                icon: icon,
                prefix: "fa",
                markerColor: color
            };
            return marker;
        }

        /**
         * Enlève les layer geojson ajoutés
         */
        function deleteGeoJsonLayers() {
            getMap().then(() => {
                api.containerFeatureGroup.removeLayer(api.geojsonFeatureGroup);

                api.geojsonFeatureGroup = new L.featureGroup();
                api.containerFeatureGroup.addLayer(api.geojsonFeatureGroup);
            });
        }

        /**
         * Supprime un layer geojson
         * @param layer
         */
        function deleteGeoJsonLayer(layer) {
            getMap().then(() => {
                api.geojsonFeatureGroup.removeLayer(layer);
            });
        }

        /**
         * Zoom sur containerFeatureGroup
         */
        function zoomToVisibleElements() {
            getMap().then((map) => {
                if (api.containerFeatureGroup.getBounds()._southWest !== undefined) {
                    map.fitBounds(api.containerFeatureGroup.getBounds().pad(0.2), api.zoomOffset);
                }
            });
        }

        /**
         * Supprime un layer GeoJson
         * @param shape
         */
        function removeShapeGeoJson(shape) {
            api.geojsonFeatureGroup.removeLayer(shape);
        }

        /**
         * Affiche une polyligne de points
         * @param pointList
         * @param style
         * @param properties
         */
        function addPolyline(pointList, style, properties) {
            let color = style.color || "red";
            let weight = style.weight || 2;
            getMap().then(() => {
                let polylineDecorator = null;

                let polyLine = new L.Polyline(pointList, {
                    id: RULE_POLYLINE,
                    color: color,
                    weight: weight * 1.5,
                    properties: properties,
                    decorator: polylineDecorator
                });

                if (style.directionnal) {
                    polylineDecorator = L.polylineDecorator(polyLine, {
                        patterns: [
                            {
                                offset: "40px",
                                repeat: "25%",
                                symbol: L.Symbol.arrowHead({
                                    pixelSize: 15 + weight * 2,
                                    pathOptions: {
                                        fillOpacity: 1,
                                        weight: 0,
                                        color: color
                                    }
                                })
                            }
                        ],
                        properties: {}
                    });
                    polyLine.options.decorator = polylineDecorator;

                    api.geojsonFeatureGroup.addLayer(polylineDecorator);
                }

                api.geojsonFeatureGroup.addLayer(polyLine);
            });
        }

        /**
         * Affiche une polyligne avec un Event
         * @param pointList
         * @param style
         * @param properties
         * @param callBack
         */
        function addPolylineWithPopupEvent(pointList, style, properties, callBack) {

            let color = style.color || "red";
            let weight = style.weight || 2;

            getMap().then(() => {
                let polylineDecorator = null;

                let polyLine = new L.Polyline(pointList, {
                    id: RULE_POLYLINE,
                    color: color,
                    weight: weight * 1.5,
                    properties: properties,
                    decorator: polylineDecorator
                });

                if (style.directionnal) {
                    polylineDecorator = L.polylineDecorator(polyLine, {
                        patterns: [
                            {
                                offset: "40px",
                                repeat: "25%",
                                symbol: L.Symbol.arrowHead({
                                    pixelSize: 15 + weight * 2,
                                    pathOptions: {
                                        fillOpacity: 1,
                                        weight: 0,
                                        color: color
                                    }
                                })
                            }
                        ],
                        properties: {}
                    });

                    polyLine.options.decorator = polylineDecorator;

                    api.geojsonFeatureGroup.addLayer(polylineDecorator);
                }

                polyLine.bindPopup();

                api.geojsonFeatureGroup.addLayer(polyLine);

                getMap().then(() => {
                    polyLine.openPopup().setPopupContent("Calcul en cours..");
                });

            });
        }

        /**
         * Ajoute un layer geojson sur la carte
         * @param geojson
         * @param style
         * @param properties options gérés :
         *    - description : Ajoute le texte de cette option dans une popup qui s'affiche lors du click
         *    - onClick : Ajoute une action sur le click de la shape
         *    - defaultStyle : Défini un style par défaut différent du style passé en paramètres
         */
        function addShapeGeoJson(geojson, style, properties) {
            getMap().then(() => addShapeGeoJsonToLayer(api.geojsonFeatureGroup, geojson, style, properties));
        }

        /**
         * Ajoute un layer geojson sur le layer passé en paramètre
         *
         * @param layer
         * @param geojson
         * @param style
         * @param properties
         */
        function addShapeGeoJsonToLayer(layer, geojson, style, properties) {
            if (properties == null) {
                properties = {};
            }

            if (properties.defaultStyle == null) {
                properties.defaultStyle = style;
            }

            getMap().then(() => {
                let geojsonLayer = new L.GeoJSON(geojson, {
                    style: style,
                    properties: properties
                });

            if (properties.description != null) {
                geojsonLayer.bindPopup(function (layer) {
                    return layer.options.properties.description;
                });
            }
            if (properties.onPopupClose) {
                geojsonLayer.on("popupclose", properties.onPopupClose);
            }

            if (properties.onClick != null) {
                geojsonLayer.on("click", properties.onClick);
            }

            if (properties.onMouseDown != null) {
                geojsonLayer.on("mousedown", properties.onMouseDown);
            }

                layer.addLayer(geojsonLayer);

                if (properties.openNow) {
                    geojsonLayer.openPopup();
                }
            });
        }

        function deleteAllLayersToLayer(layer) {
            layer.clearLayers();
        }

        /**
         * Retourne la liste des layers geoJson contenus dans le FeatureGroup
         * @returns [Layer]
         */
        function getGeoJSONShapeList() {
            return api.geojsonFeatureGroup.getLayers();
        }

        /**
         * Défini la callback appelé lorsqu'un overlay est chargé par la directive
         * @param callback
         */
        function setOverlayLoadedCallback(callback) {
            api.directiveProperties.overlayLoadedCallback = function (layer, markers) {
                if (callback != null) {
                    callback(layer, markers);
                }
                // Hack : Lancer l'evenement de bringToFront légèrement délayé pour que la map ai eu le temps de tracer l'overlay.
                setTimeout(function () {
                    bringContainerLayerToFront();
                }, 0);
            };
        }

        /**
         * Ajoute les controls pour l'echelle
         */
        function addScaleControl(map, opt) {
            let options = opt ? opt : {"position": "bottomright"};

            if (!scaleControl) {
                scaleControl = new L.control.scale(options);

                map.addControl(scaleControl);
            }
        }

        /**
         * Redéfinition de la méthode Draw.polyline.addVertex de base
         * @param singleLine
         */
        function defineCustomAddVertex(singleLine) {
            L.Draw.Polyline.prototype.addVertex = function (latlng) {
                let markersLength = this._markers.length;
                // markersLength must be greater than or equal to 2 before intersections can occur

                if (markersLength >= 2 && !this.options.allowIntersection && this._poly.newLatLngIntersects(latlng)) {
                    this._showErrorTooltip();
                    return;
                } else if (this._errorShown) {
                    this._hideErrorTooltip();
                }

                this._markers.push(this._createMarker(latlng));

                this._poly.addLatLng(latlng);

                if (this._poly.getLatLngs().length === 2) {
                    this._map.addLayer(this._poly);
                }

                this._vertexChanged(latlng, true);
                if (singleLine) {
                    markersLength = this._markers.length;
                    //Redefiniation de la méthode de base seulement en mode singleLine.
                    if (markersLength == 2) {
                        this._fireCreatedEvent();
                        this.disable();
                    }
                }
            };

        }

        /**
         * Ajoute les controls pour le dessin
         * @param params
         * @param onCreate
         * @param onDrawStart Retourne true ou false en fonction de si l'evenement est validé ou nom
         * @param polylineTextTranslation
         */
        function addDrawControls(params, onCreate, onDrawStart, polylineTextTranslation, scope) {
            drawControl = new L.Control.Draw(params);
            translateDrawControlsInFrench();

            if (polylineTextTranslation != null) {
                L.drawLocal.draw.toolbar.buttons.polyline = polylineTextTranslation;
            }

            getMap().then((map) => {
                map.addControl(drawControl);
                map.on("draw:drawstart", function (e) {
                    editionManager.currentMode = "drawing";
                    if (onDrawStart != null) {

                        if (!onDrawStart()) {
                            // Cancel the click
                            setDrawControlsVisibility(true);
                        }
                    }
                });
                map.on("draw:created", function (e) {
                    editionManager.currentMode = "";
                    if (onCreate != null) {
                        onCreate(e.layer, scope);
                    }
                });
            });
        }

        /**
         * Calcule route polyline
         */
        function calculateRoutePolyline(polyLineDrawEvent, scope) {
            addPolylineWithPopupEvent(polyLineDrawEvent.getLatLngs(), {color: polyLineDrawEvent.options.color}, {});
            calculateDistances(polyLineDrawEvent, scope);
        }


        /**
         * Fonction ajouté dans la callback délégué sur l'ouverture de d'une popup
         * @param polyLine
         * @param scope
         */
        function calculateDistances(polyLine, scope) {
			let geometry = {};
			let popupContent;

			const listOfPoints = polyLine.getLatLngs().map(geoData => {
				return {
					lat: geoData["lat"].toString(),
					lng: geoData["lng"].toString(),
				};
			});

			FitiSubscriptionService.getRouteGeometryFromPolyLine(listOfPoints).then(data => {

				const routes = data.routes;
				if (routes == null || routes.length === 0) {
					console.error("Calcul des distances : Réponse vide");
					return;
				}

				const mainRoute = routes[0];

				geometry = mainRoute.geometry;

				popupContent =
					"<div  class='okina-leaflet-default-pop-up'>" +
					"<okina-route-rule-infos real-distance='data.distance' points='data.listOfPoints'></okina-route-rule-infos>" +
					"</div class='okina-leaflet-default-pop-up'>";

				let childScope = scope.$new(true);
				childScope.data = {
					distance: mainRoute.distance,
					listOfPoints: listOfPoints
				};

				popupContent = Utils.compileHtmlElement(popupContent, $compile, childScope);

            }).finally(() => {
                getMap().then(map => {
                    map.eachLayer(layer => {
                        if (layer.options.id === RULE_POLYLINE) {
                            removeShapeGeoJson(layer);
                        }
                    });
                    let style = {
                        "color": "blue",
                        "weight": 3,
                        fillOpacity: 0.0
                    };
                    let properties = {
                        id: RULE_POLYLINE,
                        onClick: (e) => {
                            e.layer.openPopup();
                        },
                        onPopupClose: (e) => {
                            map.eachLayer(layer => {
                                if (layer.options.id === RULE_POLYLINE
                                    || (layer.options.properties && layer.options.properties.id === RULE_POLYLINE)) {
                                    removeShapeGeoJson(layer);
                                }
                            });
                        },
                        description: popupContent,
                        openNow: true
                    };
                    addShapeGeoJson(geometry, style, properties);
                });
            });
        }

        /**
         * Récupére la distance à vol d'oiseau d'une ligne tracé par l'utilisateur
         */
        function getAsCrowsFliesDistanceFromRule(polyLine) {
            const lat1 = polyLine.getLatLngs()[0]["lat"];
            const lng1 = polyLine.getLatLngs()[0]["lng"];

            const lat2 = polyLine.getLatLngs()[polyLine.getLatLngs().length - 1]["lat"];
            const lng2 = polyLine.getLatLngs()[polyLine.getLatLngs().length - 1]["lng"];

            const dist = MapUtils.getDistanceFromLatLonInKm(lat1, lng1, lat2, lng2);
            return MapUtils.getFormatedMetricDistance(dist, true);
        }

        /**
         * Affiche ou cache les controls
         * @param visible
         */
        function setDrawControlsVisibility(visible) {
            getMap().then((map) => {
                if (visible === true) {
                    map.removeControl(drawControl);
                    map.addControl(drawControl);
                } else {
                    map.removeControl(drawControl);
                }
            });
        }

        /**
         * Selectionne une shape
         *  Défini le selected shape
         *  Change le style
         *
         * @param layerSelected
         * @param selectedStyle
         * @param defaultStyle
         */
        function selectShape(layerSelected, selectedStyle, defaultStyle) {
            api.geojsonFeatureGroup.eachLayer(function (layer) {
                if (layer._leaflet_id === layerSelected._leaflet_id) {
                    layer.setStyle(selectedStyle);
                    editionManager.selectedShape = layerSelected;
                } else {
                    if (layer.options.properties.defaultStyle != null) {
                        defaultStyle = layer.options.properties.defaultStyle;
                    }
                    if (defaultStyle != null) {
                        layer.setStyle(defaultStyle);
                    }
                }
            });
        }

        /**
         * Ajoute n'importe quel évenement sur la Map
         * avec un timeout de 1sec pour ne pas déclencher d'appels trop proches
         *
         * @param event
         * @param callback
         * @param wait en millisecond
         */


        function addEventOnMap(event, wait, callback) {
            if (event === "moveend") { // Hack to avoid trigerring event on map load
                addEventOnMap("dragend", wait, callback);
                addEventOnMap("zoomend", wait, callback);
                return;
            }

            getMap().then((map) => {
                if (wait > 0) {
                    map.on(event, () => {
                        if (timeout != null) {
                            $timeout.cancel(timeout);
                        }
                        timeout = $timeout(() => {
                            callback();
                        }, wait);
                    });
                } else {
                    map.on(event, callback);
                }
            });
        }

        /**
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds. If `immediate` is passed, trigger the function on the
         * leading edge, instead of the trailing.
         *
         * @param func
         * @param wait
         * @param immediate
         * @returns {Function}
         */
        function debounce(func, wait, immediate) {
            let timeout;
            return function () {
                let context = this, args = arguments;
                let later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                let callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait !== undefined ? wait : 500);
                if (callNow) func.apply(context, args);
            };
        }

        /**
         * Ajout un widget
         * @param $scope
         * @param options: {
         *                      type -> Valeurs possibles : institution-center, overlays, load-assignment-filter
         *                      position: 'top/bottom+left/right'
         *                 }
         * @param properties -> Valeurs a passer en paramètre de la directive
         */
        function addWidget($scope, options, properties) {

            if (api.widgets[options.type] != null) {
                console.log("Widget déja ajouté !");
            }

            getMap().then((map) => {
                let widget = L.control({
                    position: options.position || "topright"
                });

                widget.onAdd = function () {
                    let parentDiv = "okina-leaflet-control";

                    // Dans le cas du widget overlay ou address-search on ne définit pas de classe a la div parent
                    // Ce widget n'a pas besoin de okina-leaflet-control
                    if (options.type === "overlays") {
                        parentDiv = "";
                    }

                    if (options.bar === true) {
                        parentDiv = "leaflet-bar";
                    }

                    if (options.large === true) {
                        parentDiv += " okina-leaflet-control-large";
                    }

                    this._div = L.DomUtil.create("div", parentDiv);
                    makeThisDivIndependentFromTheMap(this);
                    return this._div;
                };

                widget.hide = function () {
                    this._div.style.display = "none";
                };

                widget.show = function () {
                    this._div.style.display = "block";
                };

                widget.update = function ($scope) {
                    let newScope = $scope.$new(true);
                    if (properties != null) {
                        for (let key in properties) {
                            newScope[key] = properties[key];
                        }
                    }

                    this._div.innerHTML = getHTMLWidgetType(options.type, properties);
                    $compile(this._div)(newScope);
                    this._div.style.display = "initial";
                };

                widget.addTo(map);

                widget.update($scope);

                if (options.type === "overlays" && !(SecurityService.checkAccess("school-iti") !== "F")) {
                    options.display = false;
                }
                if (options.display === false) {
                    widget.hide();
                }

                api.widgets[options.type] = widget;
            });
        }

        // Create additional Control placeholders
        function addControlPlaceholders(map) {
            let corners = map._controlCorners,
                l = "leaflet-customs-corners-",
                container = map._controlContainer;

            function createCorner(vSide, hSide) {
                let className = l + vSide + " " + l + hSide;

                corners[vSide + hSide] = L.DomUtil.create("div", className, container);
            }

            createCorner("topleft", "right");
        }


        /**
         * Cache un widget
         * @param type
         */
        function hideWidget(type) {
            const widget = api.widgets[type];
            if (widget != null) {
                widget.hide();
            } else {
                console.error("Widget non ajouté.");
            }
        }

        /**
         * Affiche un widget
         * @param type
         */
        function showWidget(type) {
            const widget = api.widgets[type];
            if (widget != null) {
                widget.show();
            } else {
                console.error("Widget non ajouté.");
            }
        }

        /**
         * Retourne l'HTML correspondant au type de widget
         * @param type -> Valeurs possibles : institution-center / load-assignment-filter / load-assignment / overlays / city-group / address-search
         * @param properties -> Directive properties
         */
        function getHTMLWidgetType(type, properties) {

            let directiveAttr = "";
            if (properties != null) {
                for (let key in properties) {
                    switch (key) {
                        /** - Institution Center Control - **/
                        case "editMode":
                            directiveAttr += " okina-map-control-edit-mode=\"" + key + "\"";
                            break;
                        case "initInstitutionCenterId":
                            directiveAttr += " okina-map-control-institution-center-id=\"" + key + "\"";
                            break;
                        /** - Load Assignement Filter Control - **/
                        case "institutionCenterName":
                            directiveAttr += " okina-map-control-institution-center-name=\"" + key + "\"";
                            break;
                        case "institutions":
                            directiveAttr += " okina-map-control-institutions=\"" + key + "\"";
                            break;
                        case "cityGroups":
                            directiveAttr += " okina-map-control-city-groups=\"" + key + "\"";
                            break;
                        case "initCityGroup":
                            directiveAttr += " okina-map-control-init-city-group=\"" + key + "\"";
                            break;
                        default:
                            return "ERROR : Propriété non géré pour " + type;
                    }
                }
            }

            switch (type) {
                case "institution-center":
                    return "<okina-map-control-institution-center " + directiveAttr + "></okina-map-control-institution-center>";

                case "load-assignment-filter":
                    return "<okina-map-control-load-assignment-filter " + directiveAttr + "><okina-map-control-load-assignment-filter/>";

                case "load-assignment":
                    return "<okina-map-control-load-assignment " + directiveAttr + "><okina-map-control-load-assignment/>";

                case "overlays":
                    return "<okina-map-control-overlays " + directiveAttr + "></okina-map-control-overlays>";

                case "city-group":
                    return "<okina-map-control-city-group " + directiveAttr + "></okina-map-control-city-group>";

                case "address-search":
                    return "<okina-map-control-address-search " + directiveAttr + "></okina-map-control-address-search>";

                case "stop-area-links":
                    return "<okina-map-control-stop-area-links " + directiveAttr + "></okina-map-control-stop-area-links>";

                default:
                    return "ERROR : Widget non géré";
            }
        }

        /**
         * Rendre un controle Leaflet indépendant de la map sur laquelle il se trouve (pour ne pas que les évènements le "traversent").
         * @param control
         */
        function makeThisDivIndependentFromTheMap(control) {
            L.DomEvent.disableClickPropagation(control._div);
            L.DomEvent.on(control._div, "mousewheel", L.DomEvent.stopPropagation);
        }

        /**
         * Ferme la dernière popup ouverte
         */
        function closeLastPopup() {
            getMap().then((map) => {
                map.closePopup();
            });
        }

        /**
         * Masque un layer en le supprimant de la carte
         * @param layer
         */
        function hideOverlay(layer) {
            getMap().then((map) => {
                map.removeLayer(layer);
                fireMapEvent("overlayremove", layer);
            });
        }

        /**
         * Affiche un layer en le supprimant de la carte
         * @param layer
         */
        function showOverlay(layer) {
            getMap().then((map) => {
                map.addLayer(layer);
                fireMapEvent("overlayadd", layer);
            });
        }

        /**
         * Affiche ou masque un marker
         * @param marker
         * @param toggle
         */
        function toggleMarker(marker, toggle) {
            let display = toggle ? "block" : "none";

            marker.getElement().style.display = display;
            marker._shadow.style.display = display;
        }

        return api;

    }]
);



